import { render, staticRenderFns } from "./JoinPasswordView.vue?vue&type=template&id=6ec6fb39&scoped=true&"
import script from "./JoinPasswordView.vue?vue&type=script&lang=js&"
export * from "./JoinPasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6fb39",
  null
  
)

export default component.exports